import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const statusVersion = () => {
	return Client.get(`/gateway/Status/Version`);
};

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/menus`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/menus`, payload);
};

const find = (merchantId, id) => {
	return Client.get(`${baseUrl}/${merchantId}/menus/${id}`);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/menus/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/menus/${id}`, payload);
};

const importItems = (merchantId, formData, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/import`, formData, payload, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};

export default {
	statusVersion,
	list,
	find,
	create,
	update,
	remove,
	importItems,
};
